import { useCallback, useEffect, useRef, useState } from 'react'

const getReadonlyIndexes = (
  values: string[],
  sourcePods: uui.domain.client.rm.BarcodePod[],
): Set<number> => {
  const pods = [...sourcePods]

  const result: Set<number> = new Set()

  values.forEach((barcode, index) => {
    const podIndex = pods.findIndex(p => p.barcode === barcode)
    if (podIndex >= 0) {
      result.add(index)
      pods.splice(podIndex, 1)
    }
  })

  return result
}

export function useActions(
  value: string[],
  apiChange: (value: string[]) => void,
  podsBarcodes: uui.domain.client.rm.BarcodePod[],
) {
  const fieldValueRef = useRef(value)
  const [readonlyIndexes, setReadonlyIndexes] = useState<Set<number>>(
    getReadonlyIndexes(value, podsBarcodes),
  )

  useEffect(() => {
    fieldValueRef.current = value
  }, [value])

  useEffect(() => {
    setReadonlyIndexes(getReadonlyIndexes(value, podsBarcodes))
  }, [value, podsBarcodes])

  const onAddBarcode = useCallback(() => {
    const updatedData = [...value, '']

    apiChange(updatedData)
  }, [apiChange, value])

  const onUpdateBarcode = useCallback(
    (index: number, newBarcode: string) => {
      const updatedData = value.map((barcode, itemIndex) =>
        itemIndex === index ? newBarcode : barcode,
      )

      apiChange(updatedData)
    },
    [apiChange, value],
  )

  const onRemoveBarcode = useCallback(
    (index, count: number = 1) => {
      const updatedData = [...value]
      updatedData.splice(index, count)

      apiChange(updatedData)
    },
    [apiChange, value],
  )

  return {
    readonlyIndexes,
    onAddBarcode,
    onUpdateBarcode,
    onRemoveBarcode,
  }
}
